import {cs}        from "../../chain-services";
import {fragments} from "../../fragments";
import {Invoke}    from "../../invoke";
import {Rerender}  from "../../rerender";

export const HookRerenderNode = ({node, next}) => cs(
    ["rerender", ({}, next) => !node.setRerenderer ? next() : Rerender({next})],
    ({rerender}, next) => fragments(
        node.setRerenderer && Invoke({
            action: () => node.setRerenderer(rerender),
        }),
        next(),
        node.renderDone(),
    ),
    ({}) => next(),
);
